var buttonInputTypes = ["button", "color", "file", "image", "reset", "submit"];

function isButton(element) {
  if (element.tagName === "BUTTON") return true;

  if (element.tagName === "INPUT") {
    var input = element;
    return buttonInputTypes.indexOf(input.type) !== -1;
  }

  return false;
}

export { isButton };